import { Box, type SxProps } from "@mui/material";
import { heroImages } from "../../staticFiles";

export default function Hero() {
  const styles: SxProps = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: 1,
    objectFit: "cover",
  };
  const defaultImage = heroImages[heroImages.length - 1];

  return (
    <Box component="picture" sx={styles}>
      {heroImages.map((hero) => (
        <source key={hero.type} srcSet={hero.src} type={hero.type} />
      ))}
      <Box
        component="img"
        src={defaultImage.src}
        role="presentation"
        alt=""
        sx={styles}
      />
    </Box>
  );
}
